export const CurrencyFormatterUtils = (amount, formatter) => {
    const currencyCode = formatter.currencyCode;
    const locale = formatter.locale;

    try {
        const currencyFormatter = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currencyCode,
            maximumFractionDigits: 0
        });
        return currencyFormatter.format(amount);
    } catch (e) {
        const currencyFormatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 0
        });
        return currencyFormatter.format(amount);
    }
}
